var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-csv-importer',{attrs:{"iconable":"","orange-theme":"","request-on-process":_vm.requestOnProcess},on:{"imported-data":function($event){return _vm.getCsvData($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }